export default "__VITE_ASSET__9nHvvB8L__"